import React, { Suspense } from 'react';
import {
  SubmitContainer,
  TopSubmit,
  BottomSubmit,
} from '../../AdminRoutes/CreateRoutes/CreateForm.styles';
import PropTypes from 'prop-types';
import DeleteCompanyButton from '../../AdminRoutes/EditRoutes/EditCompany/CompanyEditDelete.component';
import SubmitEditCompany from '../../AdminRoutes/EditRoutes/EditCompany/CompanyEditSubmit.component';

const SettingsButtons = ({
  company = {},
  address,
  setIsOpen,
  setSuccessState,
  successState,
  logo = '',
}) => {
  const fullCompany = {
    ...company,
    address: address,
  };

  return (
    <>
      <SubmitContainer>
        <TopSubmit>
          {successState.length > 0 && <p className="result">{successState}</p>}
        </TopSubmit>
        <BottomSubmit>
          <Suspense fallback={<p>Loading delete button...</p>}>
            <DeleteCompanyButton
              id={company?._id}
              setIsOpen={setIsOpen}
              setSuccessState={setSuccessState}
            />
          </Suspense>
          <Suspense fallback={<p>Loading submit button...</p>}>
            <SubmitEditCompany
              company={fullCompany}
              setIsOpen={setIsOpen}
              setSuccessState={setSuccessState}
              logo={logo}
            />
          </Suspense>
        </BottomSubmit>
      </SubmitContainer>
    </>
  );
};

SettingsButtons.propTypes = {
  company: PropTypes.object,
  address: PropTypes.object,
  setIsOpen: PropTypes.func,
  setSuccessState: PropTypes.func,
  logo: PropTypes.string,
  successState: PropTypes.string,
};

export default SettingsButtons;
